import { cva } from '@/styled-system/css';

export const dotRecipe = cva({
  base: {
    width: '300',
    height: '300',
    borderRadius: '150',
  },
  variants: {
    activeType: {
      forRent: {
        backgroundColor: 'purple.400',
      },
      offMarket: {
        backgroundColor: 'icon.action.disabled',
      },
    },
  },
});
